import styled from 'styled-components';

import colors from '@/design/colors';
import { HeadingLarge, Text } from '@/design/typography';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  width: 400px;
  height: 100vh;

  justify-content: center;
  align-items: left;

  img {
    width: 100px;
    margin-bottom: 12px;
  }

  h3 {
    color: ${colors.black};

    ${HeadingLarge(18)};

    margin-bottom: 8px;
  }

  p {
    color: ${colors.gray300};

    ${Text(14)};
    margin-bottom: 15px;
  }
`;

export const ProgressBarContainer = styled.div`
  width: 100%;
  height: 6.5px;
  flex-shrink: 0;
  border-radius: 999px;
  background: ${colors.gray100};
`;

export const ProgressBar = styled.div<{
  progress: number;
  transitionMs: number;
}>`
  width: ${({ progress }) => `${progress}%`};
  height: 6.5px;
  border-radius: 999px;
  background: ${colors.purple100};
  transition: width, ease-out ${({ transitionMs }) => `${transitionMs}ms`};
`;
